import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './layout/';
import '@src/common/resetMobile.css';

/* eslint-disable no-undef */
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
